import { render, staticRenderFns } from "./ModalSendArchive.vue?vue&type=template&id=067948d6&scoped=true"
import script from "./ModalSendArchive.vue?vue&type=script&lang=js"
export * from "./ModalSendArchive.vue?vue&type=script&lang=js"
import style0 from "./ModalSendArchive.vue?vue&type=style&index=0&id=067948d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067948d6",
  null
  
)

export default component.exports